import { render, staticRenderFns } from "./PageTitleBar.vue?vue&type=template&id=3d85d734&scoped=true"
import script from "./PageTitleBar.vue?vue&type=script&lang=js"
export * from "./PageTitleBar.vue?vue&type=script&lang=js"
import style0 from "./PageTitleBar.vue?vue&type=style&index=0&id=3d85d734&prod&scoped=true&lang=scss"
import style1 from "./PageTitleBar.vue?vue&type=style&index=1&id=3d85d734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d85d734",
  null
  
)

export default component.exports